import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Select from 'react-select';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';
import { listVRFIndoor } from '../../redux/vrf/vrf_indoor_actions';
import { listVRFOutdoor } from '../../redux/vrf/vrf_outdoor_actions';

// FRS 4.2.1 (revision 20260826) - VRF System form
// 3 แท็บตาม mockup หน้า 6-8: Basic Info / Outdoor Unit / Indoor Units
// ใช้ nav-tabs toggle เอง (ไม่ใช้ react-bootstrap <Tabs>) — bug เดิม: Tabs ไม่ render
// children ตรงๆ ทำให้ Form.deepMap หา FieldGroup ไม่เจอ + remount → infinite setState loop
export class VRFSystemDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
    const sys = props.system || {};
    this.state = {
      activeTab: 'basic',
      outdoorId: sys.outdoor ? sys.outdoor.id : sys.outdoor_id || null,
      // indoorItems: [{ indoorTypeId, quantity }]
      // sys.indoors comes flattened from VRFSystemSerializer.get_indoors() —
      // each entry IS the indoor type's own serialized fields (id/name/...)
      // merged with quantity, not a nested indoor_type object.
      indoorItems: (sys.indoors || []).map(it => ({
        indoorTypeId: it.id,
        quantity: it.quantity || 1,
      })),
      addIndoorId: null,
      addIndoorQty: 1,
    };
  }

  componentDidMount() {
    this.props.listIndoor();
    this.props.listOutdoor();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.system !== this.props.system && nextProps.system) {
      const sys = nextProps.system;
      this.setState({
        outdoorId: sys.outdoor ? sys.outdoor.id : sys.outdoor_id || null,
        indoorItems: (sys.indoors || []).map(it => ({
          indoorTypeId: it.id,
          quantity: it.quantity || 1,
        })),
      });
    }
  }

  getData() {
    return {
      ...this.formRef.getFormData([]),
      outdoorId: this.state.outdoorId,
      indoorItems: this.state.indoorItems,
    };
  }

  addIndoor() {
    const { addIndoorId, addIndoorQty, indoorItems } = this.state;
    if (!addIndoorId) return;
    if (indoorItems.some(it => it.indoorTypeId === addIndoorId)) return;
    this.setState({
      indoorItems: [
        ...indoorItems,
        { indoorTypeId: addIndoorId, quantity: Number(addIndoorQty) || 1 },
      ],
      addIndoorId: null,
      addIndoorQty: 1,
    });
  }

  removeIndoor(indoorTypeId) {
    this.setState({
      indoorItems: this.state.indoorItems.filter(
        it => it.indoorTypeId !== indoorTypeId,
      ),
    });
  }

  updateIndoorQty(indoorTypeId, quantity) {
    this.setState({
      indoorItems: this.state.indoorItems.map(it =>
        it.indoorTypeId === indoorTypeId ? { ...it, quantity } : it,
      ),
    });
  }

  renderTabNav() {
    const { t } = this.props;
    const { activeTab } = this.state;
    const tab = (key, label) => (
      <li className={activeTab === key ? 'active' : ''}>
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            this.setState({ activeTab: key });
          }}
        >
          {label}
        </a>
      </li>
    );
    return (
      <ul className="nav nav-tabs" style={{ marginBottom: 15 }}>
        {tab('basic', t('basic info'))}
        {tab('outdoor', t('outdoor unit'))}
        {tab('indoor', t('indoor units'))}
      </ul>
    );
  }

  renderIndoorTab() {
    const { t, indoorOptions } = this.props;
    const { indoorItems, addIndoorId, addIndoorQty } = this.state;
    const byId = id => indoorOptions.find(o => o.id === id) || {};
    const options = indoorOptions
      .filter(o => !indoorItems.some(it => it.indoorTypeId === o.id))
      .map(o => ({ value: o.id, label: o.name }));

    return (
      <div style={{ padding: 10 }}>
        <p style={{ color: '#888' }}>
          {t('select indoor unit from library (multi-select + quantity)')}
        </p>
        <table className="table">
          <thead>
            <tr>
              <th>{t('indoor unit')}</th>
              <th style={{ width: 120 }}>{t('indoor form')}</th>
              <th style={{ width: 140 }}>{t('cooling capacity')}</th>
              <th style={{ width: 90 }}>{t('qty')}</th>
              <th style={{ width: 90 }} />
            </tr>
          </thead>
          <tbody>
            {indoorItems.length === 0 && (
              <tr>
                <td colSpan={5} style={{ color: '#aaa' }}>
                  {t('no indoor units')}
                </td>
              </tr>
            )}
            {indoorItems.map(it => {
              const ind = byId(it.indoorTypeId);
              return (
                <tr key={it.indoorTypeId}>
                  <td>{ind.name || `#${it.indoorTypeId}`}</td>
                  <td>{ind.indoor_form || '-'}</td>
                  <td>
                    {ind.cooling_capacity != null
                      ? `${ind.cooling_capacity} ${ind.unit || ''}`
                      : '-'}
                  </td>
                  <td>
                    <input
                      type="number"
                      min={1}
                      className="form-control"
                      value={it.quantity}
                      disabled={this.props.disabled}
                      onChange={e =>
                        this.updateIndoorQty(it.indoorTypeId, e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-link"
                      disabled={this.props.disabled}
                      onClick={() => this.removeIndoor(it.indoorTypeId)}
                    >
                      {t('remove')}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!this.props.disabled && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ flex: 1, marginRight: 10 }}>
              <Select
                classNamePrefix="react-select"
                placeholder={t('select indoor unit from library')}
                value={options.filter(o => o.value === addIndoorId)}
                options={options}
                onChange={opt =>
                  this.setState({ addIndoorId: opt ? opt.value : null })
                }
              />
            </div>
            <input
              type="number"
              min={1}
              style={{ width: 80, marginRight: 10 }}
              className="form-control"
              value={addIndoorQty}
              onChange={e => this.setState({ addIndoorQty: e.target.value })}
            />
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => this.addIndoor()}
            >
              {t('add indoor')}
            </button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      system,
      t,
      disabled,
      fieldErrors,
      outdoorOptions,
      ...otherAttr
    } = this.props;
    const { name, description } = system || {};
    const { activeTab, outdoorId } = this.state;
    const customAttr = { disabled };
    const outdoorSelectOptions = outdoorOptions.map(o => ({
      value: o.id,
      label: o.name,
    }));

    return (
      <div>
        {this.renderTabNav()}

        <div style={{ display: activeTab === 'basic' ? 'block' : 'none' }}>
          <Form
            {...otherAttr}
            ref={ref => (this.formRef = ref)}
            errorMessage={getErrorValue(fieldErrors, 'detail')}
          >
            <FieldGroup
              id="vrf-system-name"
              field="name"
              type="text"
              label={t('system name')}
              placeholder="VRF-1"
              value={name}
              validators={[requiredValidator]}
              errorMessage={getErrorValue(fieldErrors, 'name')}
              {...customAttr}
            />
            <FieldGroup
              id="vrf-system-description"
              field="description"
              componentClass="textarea"
              label={t('description')}
              value={description}
              {...customAttr}
            />
          </Form>
        </div>

        <div
          style={{
            display: activeTab === 'outdoor' ? 'block' : 'none',
            padding: 10,
          }}
        >
          <p style={{ color: '#888' }}>
            {t('one vrf system has exactly one outdoor unit')}
          </p>
          <div className="form-group">
            <label>{t('outdoor unit')}</label>
            <Select
              classNamePrefix="react-select"
              isDisabled={disabled}
              placeholder={t('select outdoor unit')}
              value={outdoorSelectOptions.filter(o => o.value === outdoorId)}
              options={outdoorSelectOptions}
              onChange={opt =>
                this.setState({ outdoorId: opt ? opt.value : null })
              }
            />
            {getErrorValue(fieldErrors, 'outdoor_id') && (
              <span className="help-block">
                {getErrorValue(fieldErrors, 'outdoor_id')}
              </span>
            )}
          </div>
        </div>

        <div style={{ display: activeTab === 'indoor' ? 'block' : 'none' }}>
          {this.renderIndoorTab()}
        </div>
      </div>
    );
  }
}

VRFSystemDetail.defaultProps = {
  system: {},
  indoorOptions: [],
  outdoorOptions: [],
};

const mapStateToProps = state => ({
  indoorOptions: state.vrfIndoor.orderedIds.map(
    id => state.vrfIndoor.objects[id],
  ),
  outdoorOptions: state.vrfOutdoor.orderedIds.map(
    id => state.vrfOutdoor.objects[id],
  ),
});

const mapDispatchToProps = dispatch => ({
  listIndoor: () => dispatch(listVRFIndoor(200, 0, null, null, null)),
  listOutdoor: () => dispatch(listVRFOutdoor(200, 0, null, null, null)),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(VRFSystemDetail),
);



// WEBPACK FOOTER //
// ./src/components/vrf/VRFSystemDetail.js